export default "__VITE_ASSET__BDrHtxVV__"